/**
 * Frontend feature flags (Vite env). Flags default OFF unless the env var is explicitly "true", so a
 * new UI stays dark until deliberately enabled per environment. Vite inlines `VITE_*` at build time.
 *
 * Fulfillment V2 (partial dispatch / warehouse coverage / per-shipment invoicing): when OFF the app
 * keeps the current screens (e.g. `StockPlanPanel`); when ON it renders the V2 planning surfaces
 * (e.g. `WarehouseCoveragePanel`). Read-only Phase 1 is safe either way.
 */
export const FULFILLMENT_V2_ENABLED: boolean =
  String(import.meta.env.VITE_FULFILLMENT_V2_ENABLED ?? '').trim().toLowerCase() === 'true';

/**
 * Sales-return LIFECYCLE UI (request → approve → receive → credit note). Mirrors the backend
 * RETURNS_LIFECYCLE_ENABLED flag so the Returns nav/routes/controls only appear when the backend accepts
 * them — otherwise the actions 400 with FEATURE_DISABLED. OFF by default.
 */
export const RETURNS_LIFECYCLE_ENABLED: boolean =
  String(import.meta.env.VITE_RETURNS_LIFECYCLE_ENABLED ?? '').trim().toLowerCase() === 'true';
